import React from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { FaTrash } from 'react-icons/fa';

const SigorRelacionadas = (props) => {

  function add_tratamento(id) {
    if (!props.state.tratamentos_selecionados.filter(item => item.id === id)[0]) {
      const tratamento = props.state.tratamentos.filter(item => item.id === id)[0]
      const tratamentos = props.state.tratamentos.filter(item => item.id !== id)

      const obj_tratamento = {
        id: tratamento.id,
        descricao: tratamento.descricao,
        codigo: tratamento.codigo
      }

      props.setState({ ...props.state, tratamentos_selecionados: [...props.state.tratamentos_selecionados, obj_tratamento], tratamentos, tratamento_id: tratamentos[0].id })
    }
  }

  function remove_tratamento(id) {
    const tratamentos_selecionados = props.state.tratamentos_selecionados.filter(item => item.id !== id)
    const devolution = props.state.all_tratamentos.filter(item => item.id === id)[0]
    let tratamentos = [devolution, ...props.state.tratamentos]

    props.setState({ ...props.state, tratamentos_selecionados, tratamentos, tratamento_id: tratamentos[0].id })
  }

  return (
    <div>
      {!props.state.loading ? <div className="form-group row">
        <label className="col-sm-12 col-form-label">Tratamentos Relacionais</label>
        <div className="input-group col-sm-12">
          <select value={props.state.tratamento_id} className="form-control" id="cameras" onChange={(e) => props.setState({ ...props.state, tratamento_id: e.target.value })}>
            {props.state.tratamentos.map(item => (
              <>{!item.relation && <option value={item.id}>{item.descricao}</option>}</>
            ))}
          </select>
          <button className='btn btn-primary' onClick={() => add_tratamento(props.state.tratamento_id)}>
            <BsPlusLg />
          </button>
        </div>
      </div>
        :
        <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
          <div className="spinner-border text-primary" role="status"></div>
        </div>}

      {props.state.tratamentos_selecionados.length > 0 &&
        <div className="row my-3">
          <div className="col-12">
            <table className='table table-striped table-hover text-center'>
              <thead>
                <th>Nome</th>
                <th>Código</th>
                <th>Ações</th>
              </thead>
              <tbody>
                {props.state.tratamentos_selecionados.map(item2 => (
                  <tr key={item2.id}>
                    <td>{item2.descricao}</td>
                    <td>{item2.codigo}</td>
                    <td><button className="btn btn-danger btn-small btn-circle m-r-5"
                      onClick={() => remove_tratamento(item2.id)}>
                      <FaTrash color='white' />
                    </button>
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>
        </div>}
    </div>
  )
}

export default SigorRelacionadas